import type { ReactNode } from 'react';
import { cn } from '@/lib/utils';

/** A titled block of content on a page. */
export function Panel({ title, action, children, className, bodyClassName }: {
  title?: ReactNode; action?: ReactNode; children: ReactNode; className?: string; bodyClassName?: string;
}) {
  return (
    <section aria-label={typeof title === 'string' ? title : undefined} className={cn('rounded-2xl border border-border bg-surface', className)}>
      {(title || action) && (
        <header className="flex min-h-[52px] items-center justify-between gap-3 px-5 pt-4">
          {title && <h2 className="text-sm font-medium text-foreground">{title}</h2>}
          {action}
        </header>
      )}
      <div className={cn('p-5', (title || action) && 'pt-3', bodyClassName)}>{children}</div>
    </section>
  );
}
